export default __webpack_public_path__ + "static/media/mintz.c2b1630e.svg";